/**
 * Завантаження одного вкладення в чат чи коментар (POST /api/chat/upload).
 *
 * Спільне для чату ефіру (useLiveChat) і гілок коментарів (useThread): роут
 * той самий, і правила ті самі — картинка чи коротке відео до 10 МБ, тільки
 * від залогіненого. Повертає {id, url, mime, width, height, name}
 */
export const uploadChatMedia = async (file, { apiBase, token, maxBytes = 10 * 1024 * 1024 }) => {
  if (!token) throw new Error('Треба увійти, щоб надсилати медіа')
  if (file.size > maxBytes) {
    throw new Error(`Файл завеликий — до ${Math.round(maxBytes / 1024 / 1024)} МБ`)
  }

  const form = new FormData()
  form.append('file', file)

  try {
    return await $fetch(`${apiBase}/api/chat/upload`, {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: form
    })
  } catch (e) {
    throw new Error(e?.data?.error?.message || 'Не вдалося завантажити файл')
  }
}
